import {styled} from "@mui/material";
import { keyframes } from '@mui/system';
import { Link } from 'react-router-dom';
import CTAButton from '@components/CTAButton';
import CheckBox from '@components/CheckBox';
import { getResponsiveCSS } from '@utils/cssHelpers';
import { getIconsByType, iconTypes } from '@services/icons';

export const Wrapper = styled('div')(
  {
    alignSelf: 'stretch',
    padding: '50px 10px 55px 20px',
    position: 'relative',
    height: 'calc(100vh - 70px)',
    display: 'flex',
    flexDirection: 'column',
  },
  ({ theme }) => ({
    borderLeft: `1px solid ${theme.palette.novotalk.$borderColorLight}`,
  })
);

export const TitleWrapper = styled('div')(
  {
    paddingBottom: 20,
    marginBottom: 20,
  },
  ({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.novotalk.$borderColorLight}`,
  })
);

export const TitleTop = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 6,
});

export const StyledLink = styled(Link)({
  textDecoration: 'none',
  display: 'flex',
});

export const StyledNewItemIcon = styled(getIconsByType(iconTypes.CREATE))({
  width: 14,
  height: 14,
  margin: '-3px 6px 0',
});

export const UsersWrapper = styled('div')({
  overflowY: 'auto',
  margin: '20px 0 -10px',
  paddingLeft: 10,
  height: 'calc(80vh - 80px)'
});

export const ActiveUser = styled('div')(
  {
    display: 'grid',
    gridTemplateColumns: '30px 42px auto 34px 34px',
    alignItems: 'center',
    minHeight: 56,
    padding: '6px 0',
  },
  ({ theme }) => ({
    borderBottom: `solid 1px ${theme.palette.novotalk.$resourcesTableBorderColor}`,
  })
);

export const ActiveUserText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  '& span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const Avatar = styled('img')({
  height: 34,
  width: 34,
  borderRadius: '50%',
  objectFit: 'cover',
});

export const StyledCheckbox = styled(CheckBox)({
  '& label.switch': {
    width: 30,
    height: 30,
  },
});

const iconStyles = ({ theme }) => ({
  fontSize: 21,
  cursor: 'pointer',
  color: theme.palette.novotalk.$textColorLightGray,
  '&:hover': {
    color: theme.palette.novotalk.$secondaryButtonColorHover,
  },
  '&:active': {
    color: theme.palette.novotalk.$secondaryButtonColorActive,
  },
});

export const StyledMessageIcon = styled(getIconsByType(iconTypes.MESSAGE))(
  iconStyles,
  {
    fontSize: 19,
  }
);

export const StyledVideoIcon = styled(getIconsByType(iconTypes.VIDEO_ON))(
  iconStyles,
  ({ isDisabled }) => ({
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    pointerEvents: isDisabled ? 'none' : 'auto',
    opacity: isDisabled ? 0.45 : 1,
  })
);

export const StyledVideoIconWrapper = styled('div')({
  position: 'relative',
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const StyledVideoIconLoader = styled('div')(({ theme }) => ({
  width: 16,
  height: 16,
  borderRadius: '50%',
  border: `2px solid ${theme.palette.novotalk.$secondaryButtonColor}`,
  borderTopColor: 'transparent',
  animation: `${spin} 0.9s linear infinite`,
}));

export const StyledCTAButton = styled(CTAButton)(
  {
    width: '100%',
    borderRadius: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  getResponsiveCSS('height', 48, 52)
);
